"use client";

import Link from "next/link";
import { useState } from "react";
import { supabase } from "@/lib/supabase";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [cooldown, setCooldown] = useState(0);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (!email.trim()) {
      setMessage("Entre ton email pour continuer.");
      return;
    }

    if (cooldown > 0) {
      return;
    }

    setLoading(true);
    setMessage("");

    const redirectTo = `${window.location.origin}/reset-password`;

    await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo,
    });

    // Message volontairement generique pour eviter de reveler si l'email existe.
    setMessage("Si un compte existe, un email de réinitialisation a été envoyé. Vérifie aussi les indésirables.");

    setLoading(false);
    setCooldown(60);
    const interval = window.setInterval(() => {
      setCooldown((current) => {
        if (current <= 1) {
          window.clearInterval(interval);
          return 0;
        }
        return current - 1;
      });
    }, 1000);
  }

  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4 pt-12 bg-linear-to-br from-violet-50 via-white to-violet-50/50">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-black text-slate-950 tracking-tight">Mot de passe oublié</h1>
          <p className="mt-2 text-sm text-slate-600">
            Entre ton email pour recevoir un lien de réinitialisation.
          </p>
          <p className="mt-1 text-xs text-slate-500">
            L&apos;ancien mot de passe reste actif tant que tu n&apos;as pas defini le nouveau depuis le lien email.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border rounded-xl px-4 py-3"
            required
          />

          <button
            type="submit"
            disabled={loading || cooldown > 0}
            className="bg-indigo-600 text-white rounded-xl py-3 disabled:opacity-60"
          >
            {loading
              ? "Envoi..."
              : cooldown > 0
                ? `Renvoyer dans ${cooldown}s`
                : "Envoyer le lien"}
          </button>

          {message && <p className="text-sm text-center text-slate-600">{message}</p>}

          <p className="text-sm text-center">
            <Link href="/login" className="text-indigo-600">
              Retour à la connexion
            </Link>
          </p>
        </form>
      </div>
    </main>
  );
}
